export const navLinks = [
  { label: "今日蹲帖", key: "today" },
  { label: "持续吃瓜", key: "feed" },
  { label: "热度榜", key: "rank" },
  { label: "专题合集", key: "collection" },
  { label: "楼层跟进", key: "floor" },
];

export const heroThread = {
  category: "顶瓜蹲帖中",
  badge: "全网热议 TOP 1",
  title: "某综艺录制现场突发离场，幕后跟拍到深夜，大瓜或迎终极反转",
  summary:
    "直播间蹲帖人数持续上涨，幕后跟进已排到第 18 楼。今晚九点或迎新进展，吃瓜吧盖楼蹲帖中，一起等后续。",
  metaChips: [
    { icon: "ri-fire-fill", label: "热度 12.8w" },
    { icon: "ri-stack-fill", label: "已盖 3186 楼" },
    { icon: "ri-eye-fill", label: "1.6w 瓜友在蹲" },
  ],
  progress: 68,
};

export const quickNews = [
  "某顶流舞台妆造对比照流出，服装组已回应",
  "通告称『行程冲突』，业内扒出新档期疑云",
  "独家：拍摄现场第三视角视频持续发酵",
  "某制片人深夜连发两条动态后又秒删",
  "商务方发声，相关合作或全部暂停观望",
  "录音室工作人员开帖，还原录音当天细节",
];

export const featuredThreads = [
  {
    tag: "沸点",
    category: "舞台现场",
    title: "演唱会返场环节灯光事故，粉丝与主办方各执一词",
    excerpt: "返场前五秒全场骤暗，后台对讲音频流出，楼层蹲帖已翻页到第 9 页。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20editorial%20cover%20of%20a%20dark%20concert%20stage%20with%20spotlight%20beams%20cutting%20through%20smoke%2C%20silhouette%20of%20performer%20back%20view%2C%20cinematic%20warm%20orange%20and%20crimson%20lighting%2C%20high%20contrast%2C%20no%20recognizable%20face%2C%20magazine%20cover%20aesthetic&width=900&height=640&seq=gossip-feat-01&orientation=landscape",
    floor: 1287,
    followers: 8900,
    time: "5 分钟前更新",
    hot: true,
  },
  {
    tag: "热",
    category: "时尚圈",
    title: "红毯两套礼服疑似撞款，造型团队暗讽文案引围观",
    excerpt: "同一晚不同品牌方连发声明，评论区风向骤变，楼层跟进排起长队。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20fashion%20cover%2C%20two%20elegant%20evening%20gowns%20displayed%20on%20mannequins%20under%20warm%20gallery%20lighting%2C%20red%20carpet%20context%2C%20golden%20and%20cream%20tones%2C%20sophisticated%20magazine%20styling%2C%20no%20human%20faces&width=900&height=640&seq=gossip-feat-02&orientation=landscape",
    floor: 764,
    followers: 5200,
    time: "12 分钟前更新",
    hot: true,
  },
  {
    tag: "蹲",
    category: "影视剧组",
    title: "新剧官宣海报主角站位变动，番位博弈疑浮出水面",
    excerpt: "片方重新上架物料，多方粉丝盖楼讨论，剧情之外另一场戏更热闹。",
    cover:
      "https://readdy.ai/api/search-image?query=movie%20poster%20grid%20background%20with%20film%20clapperboard%20and%20spotlight%2C%20cinematic%20warm%20tones%2C%20stylized%20editorial%20drama%20cover%2C%20layered%20light%20and%20shadow%2C%20no%20recognizable%20actors&width=900&height=640&seq=gossip-feat-03&orientation=landscape",
    floor: 539,
    followers: 4100,
    time: "19 分钟前更新",
    hot: false,
  },
  {
    tag: "新",
    category: "音乐圈",
    title: "新歌发行后一小时紧急改词，作词人深夜发文回应",
    excerpt: "歌词疑指代引发争议，改版前后对比已在楼层内逐句扒过。",
    cover:
      "https://readdy.ai/api/search-image?query=music%20studio%20editorial%20cover%20with%20microphone%2C%20sheet%20music%20and%20neon%20warm%20light%20glow%2C%20cinematic%20magazine%20aesthetic%2C%20no%20person%2C%20rich%20amber%20and%20teal%20contrast&width=900&height=640&seq=gossip-feat-04&orientation=landscape",
    floor: 208,
    followers: 2600,
    time: "32 分钟前更新",
    hot: false,
  },
];

export const timelineThreads = [
  {
    id: "n1",
    category: "综艺",
    categoryTone: "accent",
    title: "录制现场冲突细节持续还原，两版监控说法对不上",
    excerpt:
      "现场观众开帖补充第三视角，与节目组说明存在出入。楼层已盖到第 214 楼，新进展随时顶上来。",
    floor: 214,
    latest: { floor: 214, by: "蹲瓜小号_09", time: "2 分钟前", text: "又有新物料放出，我先把对比放下面，大家看看角度对不对。" },
    watching: true,
  },
  {
    id: "n2",
    category: "感情瓜",
    categoryTone: "primary",
    title: "同城偶遇照连发两帖，工作室至今未表态",
    excerpt:
      "偶遇楼主实锤时间线，另一帖提出反证。两边瓜友互相蹲守，等一纸声明落地。",
    floor: 168,
    latest: { floor: 168, by: "吃瓜群众甲", time: "7 分钟前", text: "蹲到第 168 楼，还没动静，我先去加热度了，有人一起吗？" },
    watching: true,
  },
  {
    id: "n3",
    category: "品牌",
    categoryTone: "secondary",
    title: "代言人首条官宣秒删，评论区考古开始",
    excerpt:
      "官号上线不到二十分钟下架，瓜友开始翻过往物料比对排期，楼层持续刷新中。",
    floor: 96,
    latest: { floor: 96, by: "楼里小助手", time: "14 分钟前", text: "补个时间线存档，需要的自取，楼层别水，蹲实在进展。" },
    watching: false,
  },
  {
    id: "n4",
    category: "直播",
    categoryTone: "accent",
    title: "连麦到一半突然断线，主播口型被逐帧解读",
    excerpt:
      "断线后直播间立刻换人，弹幕与楼层都在逐帧复盘现场那一句，后续或见真章。",
    floor: 63,
    latest: { floor: 63, by: "帧帧狙", time: "21 分钟前", text: "逐帧放完，嘴型对不上的概率很大，等完整录播出来再验。" },
    watching: true,
  },
];

export const floorUpdates = [
  { floor: 214, by: "蹲瓜小号_09", time: "2 分钟前", text: "又有新物料放出，我把对比放下面了，角度大家帮我看看是不是同一现场。", likes: 521, replies: 44, tone: "accent" },
  { floor: 211, by: "吃瓜群众甲", time: "16 分钟前", text: "两版监控同一秒画面对不上，蹲楼太值了，今晚大概率有真进展。", likes: 468, replies: 37, tone: "primary" },
  { floor: 205, by: "楼上说得对", time: "28 分钟前", text: "别带节奏，等官方把完整版放出来再下结论，先搬个凳子。", likes: 396, replies: 29, tone: "secondary" },
  { floor: 199, by: "瓜田值守员", time: "41 分钟前", text: "补充：这段音轨此前从未公开，来源标注已贴上，理性吃瓜。", likes: 344, replies: 21, tone: "primary" },
];

export const hotRank = [
  { rank: 1, title: "录制现场冲突细节持续还原，监控对不上", tag: "持续蹲", floor: 3186, heat: "12.8w", delta: "+高" },
  { rank: 2, title: "同城偶遇连发两帖，声明迟迟未落地", tag: "感情", floor: 2405, heat: "10.2w", delta: "+高" },
  { rank: 3, title: "返场灯光事故，双方各执一词", tag: "舞台", floor: 1893, heat: "9.4w", delta: "+高" },
  { rank: 4, title: "礼服疑似撞款，造型方暗讽回应", tag: "时尚", floor: 1520, heat: "8.1w", delta: "稳" },
  { rank: 5, title: "官宣海报站位变动，番位疑云", tag: "剧组", floor: 1187, heat: "6.7w", delta: "新" },
  { rank: 6, title: "代言官宣秒删，评论区考古进行中", tag: "品牌", floor: 964, heat: "5.2w", delta: "+中" },
  { rank: 7, title: "新歌发行一小时改词，逐句对比", tag: "音乐", floor: 741, heat: "4.3w", delta: "新" },
  { rank: 8, title: "连麦中途断线，口型逐帧解读", tag: "直播", floor: 620, heat: "3.8w", delta: "稳" },
];

export const hotTags = [
  "返场事故", "番位博弈", "偶遇实锤", "歌词疑云", "秒删考古", "档期撞车", "后台音频", "声明迟迟未落", "礼服撞款", "红毯名场面",
];

export const collections = [
  {
    title: "录制冲突全记录",
    sub: "从突发离场到监控对不上，一条线扒到底",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20cover%20of%20backstage%20studio%20corridor%20with%20dramatic%20warm%20lighting%20and%20long%20shadows%2C%20dark%20red%20and%20amber%20tones%2C%20magazine%20style%2C%20no%20person%20face&width=680&height=880&seq=gossip-col-01&orientation=portrait",
    entries: 32,
    follow: "3.1w",
    tone: "accent",
  },
  {
    title: "红毯名场面复盘",
    sub: "礼服撞款、造型暗讽，时尚圈那点事",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20fashion%20magazine%20cover%20with%20red%20carpet%20bokeh%20background%2C%20golden%20warm%20glow%2C%20glamorous%20dress%20fabric%20close%20up%2C%20no%20faces%2C%20sophisticated%20styling&width=680&height=880&seq=gossip-col-02&orientation=portrait",
    entries: 21,
    follow: "2.4w",
    tone: "primary",
  },
  {
    title: "番位博弈观察帖",
    sub: "海报站位、物料排期里的细节",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20wall%20with%20dramatic%20spotlight%2C%20drama%20movie%20billing%20block%20typography%20vibe%2C%20warm%20shadow%20light%2C%20no%20actors%2C%20editorial%20style&width=680&height=880&seq=gossip-col-03&orientation=portrait",
    entries: 18,
    follow: "1.9w",
    tone: "secondary",
  },
  {
    title: "声明迟迟未落",
    sub: "那些蹲到地老天荒的等待楼",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20editorial%20cover%20of%20an%20empty%20waiting%20room%20bench%20under%20a%20single%20warm%20lamp%2C%20long%20evening%20shadow%2C%20anticipation%20mood%2C%20cinematic%20no%20person&width=680&height=880&seq=gossip-col-04&orientation=portrait",
    entries: 40,
    follow: "4.6w",
    tone: "accent",
  },
  {
    title: "歌词逐句解密",
    sub: "音乐人字里行间的那些暗线",
    cover:
      "https://readdy.ai/api/search-image?query=lyrics%20handwriting%20on%20paper%20with%20vintage%20record%20player%20and%20warm%20desk%20lamp%20glow%2C%20amber%20toned%20editorial%20cover%2C%20no%20person%2C%20cinematic%20detail&width=680&height=880&seq=gossip-col-05&orientation=portrait",
    entries: 15,
    follow: "1.2w",
    tone: "primary",
  },
];

export const communityPosts = [
  { avatar: "吃", name: "吃瓜群众甲", role: "吃瓜十级", time: "刚刚", text: "今晚这楼蹲得值，新进展随时顶上来了，大家别走开。", hot: true },
  { avatar: "楼", name: "楼里小助手", role: "整理存档", time: "6 分钟前", text: "把断线前后的时间线整理成一页了，需要的瓜友自取。", hot: false },
  { avatar: "帧", name: "帧帧狙", role: "细节猎人", time: "15 分钟前", text: "监控两版不同秒的截图叠在一起了，角度确实对不上。", hot: false },
  { avatar: "蹲", name: "蹲到天亮", role: "资深蹲友", time: "22 分钟前", text: "先声明一下，理性吃瓜，声明没落之前不下结论。", hot: false },
];

export const footNav = {
  about: ["关于吃瓜吧", "平台规则", "编辑部成员", "联系方式", "加入我们"],
  play: ["如何盖楼蹲帖", "楼层跟进说明", "瓜友守则", "谣言求证机制", "更新提醒设置"],
  biz: ["内容合作", "品牌入驻", "媒体报道", "版权声明", "意见反馈"],
};